module.exports = __webpack_public_path__ + "img/86-07c6ea.png";